export default __webpack_public_path__ + "static/media/website.797ab121.svg";